module.exports = __webpack_public_path__ + "static/media/message-check.89544dac.svg";